/**
 * @fileoverview Agent definition for plot-thread-snapshotter-v1.
 *
 * Performs an incremental update of the plot-thread catalog given the set
 * of plot threads known so far plus the content of a single chapter. Runs
 * as part of the snapshot pipeline (Stage 1, in parallel with plot and
 * character snapshotters) and is also reused by plot-thread-extractor-v1
 * as the per-chunk worker for large imports.
 *
 * Unlike plot-thread-extractor-v1 (import-time, complete narratives), this
 * agent understands that the story may be incomplete and adapts accordingly.
 *
 * @category narrative.snapshot.threads
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'plot-thread-snapshotter-v1',
  kind: 'primitive',
  name: 'Plot Thread Snapshotter',
  description: 'Incrementally updates the plot-thread catalog from existing plot-thread data plus the content of a single chapter. Designed for partial narratives.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'experimental',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.snapshot.threads',
    usedBy: ['use-plot-thread-snapshotter-v1'],
    usedInComposites: [],
    relatedAgents: [
      'plot-thread-extractor-v1',
      'weave-snapshotter-v2',
      'plot-snapshotter-v2',
    ],
  },
};
